import script from "./Screen.vue?vue&type=script&setup=true&lang=js"
export * from "./Screen.vue?vue&type=script&setup=true&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=5ae71790&lang=scss"

const __exports__ = script;

export default __exports__